import { CButton, CCol, CInput, CLabel, CRow, CSelect } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../common/CommonList";
import { apiCall, apisResponseDownload } from "src/_apiConfig/apiCall";
import Options from "../common/Options";
import Auth from "src/auth";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  FilterContains,
  FilterContainsInsensitive,
  FilterEqual,
  FilterKeyWord,
} from "../common/FilterCondition";

import { formatDate } from "src/shared/Format/dateFormat";
import TableButtonClick from "../common/Table/TableButtonClick";

const ChequePaymentReport = () => {
  const [usersData, setuserData] = useState();
  const [AllUsersData, setAllUsersData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("Amount");
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  const [MRNO, setMRNO] = useState();
  const [ChequeNo, setChequeNo] = useState();
  const [LotNo, setLotNo] = useState();
  const [Mobile, setMobile] = useState();
  const [CompanyName, setCompanyName] = useState();
  const [StartInsertDate, setStartInsertDate] = useState();
  const [EndInsertDate, setEndInsertDate] = useState();
  const [itemPerPage, setItermPerPage] = useState(10);

  const { authenticated } = Auth();

  useEffect(() => {
    //orderClick ? setorder("asc") : setorder("desc");
    getBGPaymentList(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimit, textField, orderClick, itemPerPage, authenticated]);

  const getBGPaymentList = async (firstRequest) => {
    if (authenticated) {
      setloading(true);
      const header = new Headers();
      let filter = "";

      filter = "&$filter=";

      filter = FilterContains(filter, "PaymentId", MRNO);

      if (authenticated.role === "CFO") {
        filter = FilterContains(filter, "circleId", authenticated.district);
      }

      if (authenticated.role === "DFO") {
        filter = FilterContains(filter, "districtId", authenticated.district);
      }
      filter = FilterContainsInsensitive(filter, "ChequeNo", ChequeNo);

      filter = FilterContainsInsensitive(filter, "LotNo", LotNo);
      filter = FilterContains(filter, "Mobile", Mobile);

      filter = FilterContainsInsensitive(filter, "CompanyName", CompanyName);

      filter = FilterKeyWord(filter, "ChequeDueDate", StartInsertDate, "ge");
      filter = FilterKeyWord(filter, "ChequeDueDate", EndInsertDate, "le");

      if (filter === "&$filter=") {
        filter = "";
      }
      console.log("filter: " + filter);
      // ${filter}header.append();

      const response = await apiCall(
        `Report/getChequePaymentList?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filter}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();

      if (response.status === 200) {
        setuserData(jsonobj);
      }

      const responseCount = await apiCall(
        `Report/getChequePaymentList?${filter}`,
        "GET",
        header,
        null
      );

      const jsonobjcount = await responseCount.json();

      if (responseCount.status === 200) {
        setAllUsersData(jsonobjcount);
      }
      setloading(false);

      pageLimit >= jsonobjcount.length - Number(itemPerPage)
        ? setdisablednext(true)
        : setdisablednext(false);

      pageLimit === 0 ? setdisabledprev(true) : setdisabledprev(false);
    }
  };

  const ExportToExcel = async () => {
    if (AllUsersData != null && AllUsersData.length > 0) {
      const header = new Headers();
      const response = await apiCall(
        `Report/ChequeReportExportToExcel?MRNO=${MRNO}&ChequeNo=${ChequeNo}&LotNo=${LotNo}&Mobile=${Mobile}&CompanyName=${CompanyName}&StartInsertDate=${StartInsertDate}&EndInsertDate=${EndInsertDate}&Role=${authenticated.role}&DistId=${authenticated.district}`,
        "GET",
        header,
        null
      );

      const jsonobj = await response;
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "ChequeaymentReport.xls";
        alink.click();
      });
    } else {
      alert("records not available");
    }
  };
  const PaymentStatusViewHanlder = async (tranid) => {
    const url = `Report/DownloadReceipt?txnId=${tranid}`;
    const documentName = `${tranid}.pdf`;

    await apisResponseDownload(url, documentName).then((res) => {
      // if (!res.success) {
      //   alert("Receipt not available");
      // }
    });
  };

  const ChequePaymentStatusViewHanlder = async (filePath) => {
    const url = `Report/DownloadCheque?filepath=${filePath}`;
    const documentName = filePath;

    await apisResponseDownload(url, documentName);
    // .then((res) => {
    //   if (!res.success) {
    //     alert("Receipt not available 11");
    //   }
    // });
  };

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "paymentId",
      _style: { width: "7%" },
      label: "MR No",
    },
    {
      key: "districtName",
      _style: { width: "15%" },
      label: TableHeaderSet("District", "districtName"),
    },
    {
      key: "amount",
      _style: { width: "7.5%" },
      label: TableHeaderSet("Amount", "amount"),
    },

    {
      key: "inserdateformat",
      label: TableHeaderSet("Insert DateTime (dd/mm/yyyy)", "inserdateformat"),
    },

    {
      key: "statusCode",
      _style: { width: "7%" },
      label: "Status",
    },
    {
      key: "lotNo",
      _style: { width: "7.5%" },
      label: "Lot No",
    },
    {
      key: "mobile",
      _style: { width: "10%" },
      label: "Mobile",
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: "Company Name",
    },
    {
      key: "chequeNo",
      _style: { width: "14.5%" },
      label: "Cheque No",
    },

    {
      key: "ChequeDateFormat",
      label: TableHeaderSet("Cheque Date (dd/mm/yyyy)", "chequeDueDate"),
    },
    {
      key: "chequeClearingStatusName",
      label: TableHeaderSet("Clearing Status", "chequeClearingStatus"),
    },
    {
      key: "ChequeClearingDateFromat",
      label: TableHeaderSet("Clearing Date (dd/mm/yyyy)", "chequeClearingDate"),
    },
    {
      key: "viewChequeDocument",
      label: "View Document",
      _style: { width: "25%" },
      sorter: false,
      filter: false,
    },
    {
      key: "viewChequePaymentReceipt",
      label: "View Receipt",
      _style: { width: "25%" },
      sorter: false,
      filter: false,
    },
  ];
  function reset() {
    setpageLimit(0);
    setItermPerPage(10);
  }

  let additional = (
    <>
      <div>
        <CRow>
          <CCol xl={3}>
            <CLabel>MR No :</CLabel>
            <CInput
              onChange={(e) => {
                setMRNO(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Cheque No :</CLabel>
            <CInput
              onChange={(e) => {
                setChequeNo(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Lot No :</CLabel>
            <CInput
              onChange={(e) => {
                setLotNo(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Mobile :</CLabel>
            <CInput
              onChange={(e) => {
                setMobile(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Company Name :</CLabel>
            <CInput
              onChange={(e) => {
                setCompanyName(e.target.value);
              }}
            />
          </CCol>

          <CCol xl={3}>
            <CLabel>Start Date :</CLabel>
            <CInput
              type="date"
              placeholder=""
              onChange={(e) => {
                setStartInsertDate(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>End Date :</CLabel>
            <CInput
              type="date"
              placeholder=""
              onChange={(e) => {
                setEndInsertDate(e.target.value);
              }}
            />
          </CCol>
        </CRow>

        <CButton
          className="mt-5"
          color="success"
          onClick={() => {
            reset();
            getBGPaymentList();
          }}
        >
          Search
        </CButton>
        <CButton
          className="mt-5 ml-2"
          color="success"
          onClick={() => {
            window.location.reload();
          }}
        >
          Clear
        </CButton>
        <CButton
          className="mt-5 ml-2"
          color="success"
          disabled={usersData != null && usersData.length > 0 ? false : true}
          onClick={() => {
            ExportToExcel();
          }}
        >
          Export To Excel
        </CButton>

        <div className="float-right col-md-auto mt-3 mb-3  ">
          <CLabel>Item Per Page</CLabel>
          <CSelect
            aria-label="Default select example"
            onChange={(e) => {
              reset();
              setItermPerPage(e.target.value);
            }}
          >
            <Options />
          </CSelect>
        </div>
      </div>
    </>
  );
  const scopedSlotsCommon = {
    inserdateformat: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.insertDateTime === null
              ? ""
              : formatDate(item.insertDateTime)}
          </span>
        </td>
      );
    },
    ChequeDateFormat: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.chequeDueDate === null ? "" : formatDate(item.chequeDueDate)}
          </span>
        </td>
      );
    },
    ChequeClearingDateFromat: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.chequeClearingDate === null
              ? ""
              : formatDate(item.chequeClearingDate)}
          </span>
        </td>
      );
    },
    viewChequeDocument: (item, index) => {
      return (
        <td className="py-2">
          <CButton
            color="info"
            onClick={() => ChequePaymentStatusViewHanlder(item.filePath)}
            className="mt-1 "
          >
            View Document
          </CButton>
        </td>
      );
    },
    viewChequePaymentReceipt: (item, index) => {
      return (
        <TableButtonClick
          isDisplayAllow={item.chequeClearingStatus === 2 ? true : false}
          isNormallBtn={true}
          buttonName={"View Receipt"}
          color={"info"}
          onClick={() => PaymentStatusViewHanlder(item.responseMessage)}
        />
      );
    },
  };

  return (
    <CRow>
      <CCol xl={12}>
        <CommonList
          items={usersData}
          fields={fields}
          listName="Cheque Payment Report"
          loading={loading}
          additional={additional}
          prev={() => setpageLimit(pageLimit - Number(itemPerPage))}
          next={() => setpageLimit(pageLimit + Number(itemPerPage))}
          disabledprev={disabledprev}
          disablednext={disablednext}
          id="userid"
          scopedSlots={scopedSlotsCommon}
        />
      </CCol>
    </CRow>
  );
};

export default ChequePaymentReport;
